import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { LimitSpecialConditions } from '../common/limit_special_conditions';
import { LimitWhatIsIncluded } from '../common/limit_what_is_included';
import { SeeAllInclusions } from '../common/see_all_inclusions';
import { IsThisProductSuitableForMe } from '../common/is_this_product_suitable_for_me';
import { Separator } from '../common/separator';
import { withQuoteFlatten } from '../common/with_quote_flatten';

const useStyles = createUseStyles((theme) => ({
    container: {
        flexGrow: 1,
        padding: {
            top: theme.spacing[20],
            right: theme.spacing[12],
            bottom: theme.spacing[16],
            left: theme.spacing[12]
        }
    },
    extraGroupContainer: {
        display: 'flex',
        marginTop: theme.spacing[8]
    },
    separator: {
        margin: {
            top: '0.2rem',
            right: theme.spacing[16],
            bottom: '0.2rem',
            left: theme.spacing[16]
        }
    }
}));

const _ProductIncluded = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    const { className, productId, productSpecialConditions, productInclusions, quote } = props;
    return (
        <div className={classNames('test-policyProductCard-included', classes.container, className)}>
            <LimitSpecialConditions specialConditions={productSpecialConditions} productId={productId} />
            <LimitWhatIsIncluded inclusions={productInclusions} productId={productId} />
            <div className={classes.extraGroupContainer}>
                <SeeAllInclusions productId={productId} />
                <Separator type="vertical" insideFlexbox className={classes.separator} />
                <IsThisProductSuitableForMe quote={quote} />
            </div>
        </div>
    );
};

_ProductIncluded.propTypes = {
    className: PropTypes.string,
    quote: PropTypes.object,
    productId: PropTypes.string,
    productSpecialConditions: PropTypes.string,
    productInclusions: PropTypes.string
};

const ProductIncluded = withQuoteFlatten(_ProductIncluded);

export { ProductIncluded };
